<!-- SAVE Button -->
<!-- <p-button
            styleClass="ms-2 mt-2"
            [disabled]="detailForm.invalid"
            (onClick)="saveContactAndAddress(model)"
            form="detailForm"
            [label]="'common.save' | translate"
        >
        </p-button> -->

<!-- EDIT Button -->
<!-- <p-button
            styleClass="ms-2 mt-2"
            [severity]="'secondary'"
            (onClick)="endEdit()"
            [label]="'common.cancel' | translate"
        >
        </p-button> -->

<!-- DELETE Button -->
<!-- <p-button
            styleClass="ms-2 mt-2"
            [severity]="'secondary'"
            (onClick)="deleteContactAndAddress(model)"
            *ngIf="model.id"
            [label]="'common.delete' | translate"
        >
        </p-button> -->

<div class="flex flex-row">
    <h6 class="mt-2 flex">{{ 'crm.contact-links' | translate }}</h6>
    @if(!isAnyContactAddressLinkTemporary()){
    <p-button
        class="flex"
        [pTooltip]="'common.set-contact-link' | translate"
        (onClick)="setContactAddressLinkToAddress()"
        icon="fa-solid fa-plus"
        [text]="true"
    ></p-button>
    }
</div>
<hr class="mt-0" />

<!-- If no address, show no contact link-->
@if(contactLinkedAddressListSignal().length == 0) {
    <p>{{ 'common.no-contact-links' | translate }}</p>
}
@else if(contactLinkedAddressListSignal()) {
    <!-- If there is address, show contact link-->
    <!-- <a [routerLink]="['/crm/contact']">{{ 'common.contact' | translate }}</a> -->
    <ul class="no-markers">
        @for(address of contactLinkedAddressListSignal(); track address) {
            <li>
                <!-- Create a Delete icon button besides -->
                 @if(!address.temporary){
                <p-button
                        [rounded]="true" 
                        [text]="true" 
                        type="submit"
                        size="small"
                        icon="fa fa-trash"
                        [pTooltip]="'common.delete' | translate"
                    (onClick)="deleteContactAddressLink(address)"
                />
                 }
                <a [routerLink]="address.href">{{ address.label }}</a>
            </li>
        }
    </ul>
}
